import { Injectable, InjectionToken, Injector } from '@angular/core'
import { BaseTrpcService } from './base-trpc.service.js'
import type { AppRootRouter } from '@lg/backend/app-root-router'
import { CsrfService } from './csrf.service.js'

export class AppTrpcService extends BaseTrpcService<AppRootRouter> {}

export const AppTrpcServiceInjectionToken = new InjectionToken<AppTrpcService>(
	'AppTrpcService',
)
